const Conditional = ({
  condition,
  children,
  elseBlock
}: {
  condition: boolean
  children: React.ReactNode | string
  elseBlock?: React.ReactNode | string
}) => {
  if (condition) {
    return <>{children}</>
  }
  if (elseBlock) {
    return <>{elseBlock}</>
  }
  return <></>
}

export default Conditional
